import { CaretDown, CaretRight } from '@phosphor-icons/react';
import type { MouseEvent } from 'react';
import { MuteText } from '../../../elements';
import { LotsExpandToggle } from './inventoryListStyled';
import {
  getLotCount,
  itemHasLots,
  type InventoryListApiItem,
} from './inventoryListTypes';

type InventoryLotsColumnTitleProps = {
  allExpanded: boolean;
  hasExpandableRows: boolean;
  onToggleAll: () => void;
};

export function InventoryLotsColumnTitle({
  allExpanded,
  hasExpandableRows,
  onToggleAll,
}: InventoryLotsColumnTitleProps) {
  return (
    <div className="d-flex flex-column">
      <MuteText>Lots</MuteText>
      {hasExpandableRows && (
        <LotsExpandToggle type="button" onClick={onToggleAll}>
          <span>{allExpanded ? 'Collapse All' : 'Expand All'}</span>
          {allExpanded ? (
            <CaretDown size={14} weight="bold" />
          ) : (
            <CaretRight size={14} weight="bold" />
          )}
        </LotsExpandToggle>
      )}
    </div>
  );
}

type InventoryLotsExpandIconProps = {
  expanded: boolean;
  record: InventoryListApiItem;
  onExpand: (record: InventoryListApiItem, event: MouseEvent<HTMLElement>) => void;
};

export function InventoryLotsExpandIcon({
  expanded,
  record,
  onExpand,
}: InventoryLotsExpandIconProps) {
  if (!itemHasLots(record)) return null;

  const lotCount = getLotCount(record);
  const label = expanded
    ? 'Collapse'
    : `${lotCount} lot${lotCount === 1 ? '' : 's'} available`;

  return (
    <LotsExpandToggle type="button" onClick={e => onExpand(record, e)}>
      <span>{label}</span>
      {expanded ? (
        <CaretDown size={14} weight="bold" />
      ) : (
        <CaretRight size={14} weight="bold" />
      )}
    </LotsExpandToggle>
  );
}
